import {
  CheckCircle,
  Files,
  FileText,
  Landmark,
  Layers,
  LayoutDashboard,
  LayoutPanelTop,
  Signal,
  Users
} from 'lucide-react'

import type { NavItem, NavItemGuest } from '@/types/common'

export const sidebarItems: Array<NavItem> = [
  {
    label: 'Dashboard',
    href: '/dashboard',
    icon: LayoutDashboard
  },
  {
    label: 'Verifikasi',
    icon: CheckCircle,
    children: [
      {
        label: 'Verifikasi Data',
        href: '/verification-data',
        module: 'verification_data',
        permission: 'verification_data.read'
      },
      {
        label: 'Verifikasi Wilker Penyuluh',
        href: '/verification-wilker-penyuluh',
        module: 'verification_data',
        permission: 'verification_data.read'
      },
      {
        label: 'Verifikasi Pindah Domisili Petani',
        href: '/ktg-penyuluh/pindah-domisili'
      }
    ]
  },
  {
    label: 'KELEMBAGAAN (KLB)',
    isGroupLabel: true,
    groupModule: [
      'petani',
      'poktan',
      'gapoktan',
      'kep',
      'posluhdes',
      'bpp',
      'dinas',
      'pusat'
    ]
  },
  {
    label: 'Kelembagaan Petani',
    icon: LayoutPanelTop,
    children: [
      {
        label: 'Daftar Petani',
        href: '/klb-petani/petani',
        module: 'petani',
        permission: 'petani.read'
      },
      {
        label: 'Daftar Poktan',
        href: '/klb-petani/poktan',
        module: 'poktan',
        permission: 'poktan.read'
      },
      {
        label: 'Daftar Gapoktan',
        href: '/klb-petani/gapoktan',
        module: 'gapoktan',
        permission: 'gapoktan.read'
      },
      {
        label: 'Daftar KEP',
        href: '/klb-petani/kep',
        module: 'kep',
        permission: 'kep.read'
      },
      {
        label: 'Cari Petani',
        href: '/klb-petani/cari-petani',
        module: 'petani',
        permission: 'petani.read'
      }
    ]
  },
  {
    label: 'Kelembagaan Penyuluh',
    icon: LayoutPanelTop,
    children: [
      {
        label: 'Desa',
        href: '/klb-penyuluh/desa',
        module: 'posluhdes',
        permission: 'posluhdes.read'
      },
      {
        label: 'Kecamatan',
        href: '/klb-penyuluh/kecamatan',
        module: 'bpp',
        permission: 'bpp.read'
      },
      {
        label: 'Kabupaten/Kota',
        href: '/klb-penyuluh/kotakab',
        module: 'dinas-kota',
        permission: 'dinas-kota.read'
      },
      {
        label: 'Provinsi',
        href: '/klb-penyuluh/provinsi',
        module: 'dinas',
        permission: 'dinas.read'
      },
      {
        label: 'Pusat',
        href: '/klb-penyuluh/pusat',
        module: 'pusat',
        permission: 'pusat.read'
      }
    ]
  },
  {
    label: 'Ketenagaan (KTG)',
    isGroupLabel: true,
    groupModule: [
      'penyuluh-asn',
      'penyuluh-thl-apbn',
      'penyuluh-thl-apbd',
      'penyuluh-swadaya',
      'penyuluh-swasta'
    ]
  },
  {
    label: 'Ketenagaan Penyuluh',
    icon: LayoutPanelTop,
    children: [
      {
        label: 'PNS & PPPK',
        href: '/ktg-penyuluh/pns-pppk',
        module: 'penyuluh-asn',
        permission: 'penyuluh-asn.read'
      },
      {
        label: 'THL APBN',
        href: '/ktg-penyuluh/apbn',
        module: 'penyuluh-thl-apbn',
        permission: 'penyuluh-thl-apbn.read'
      },
      {
        label: 'THL APBD',
        href: '/ktg-penyuluh/apbd',
        module: 'penyuluh-thl-apbd',
        permission: 'penyuluh-thl-apbd.read'
      },
      {
        label: 'Swadaya',
        href: '/ktg-penyuluh/swadaya',
        module: 'penyuluh-swadaya',
        permission: 'penyuluh-swadaya.read'
      },
      {
        label: 'Swasta',
        href: '/ktg-penyuluh/swasta',
        module: 'penyuluh-swasta',
        permission: 'penyuluh-swasta.read'
      }
    ]
  },
  {
    label: 'Manajeman Pengguna',
    isGroupLabel: true
  },
  {
    label: 'Pengguna',
    icon: LayoutPanelTop,
    children: [
      {
        label: 'Administrator',
        href: '/user/admin'
      },
      {
        label: 'Admin Provinsi',
        href: '/user/provinsi'
      },
      {
        label: 'Admin Kab/ Kota',
        href: '/user/kabupaten'
      },
      {
        label: 'Admin Kecamatan',
        href: '/user/bpp'
      }
    ]
  }
]

export const genderOptions = [
  {
    label: 'Laki-laki',
    value: 'L'
  },
  {
    label: 'Perempuan',
    value: 'P'
  }
]

export const dummyOptions = [
  {
    label: 'Dummy Option 1',
    value: 'dummy1'
  },
  {
    label: 'Dummy Option 2',
    value: 'dummy2'
  },
  {
    label: 'Dummy Option 3',
    value: 'dummy3'
  }
]

export const rolesOptions = [
  {
    label: 'Ketua',
    value: 'ketua'
  },
  {
    label: 'Sekretaris',
    value: 'sekretaris'
  },
  {
    label: 'Bendahara',
    value: 'bendahara'
  },
  {
    label: 'Anggota',
    value: 'anggota'
  },
  {
    label: 'Calon Angota',
    value: 'calon_anggota'
  }
]

export const monthsOptions = [
  { label: 'Januari', value: '1' },
  { label: 'Februari', value: '2' },
  { label: 'Maret', value: '3' },
  { label: 'April', value: '4' },
  { label: 'Mei', value: '5' },
  { label: 'Juni', value: '6' },
  { label: 'Juli', value: '7' },
  { label: 'Agustus', value: '8' },
  { label: 'September', value: '9' },
  { label: 'Oktober', value: '10' },
  { label: 'November', value: '11' },
  { label: 'Desember', value: '12' }
]

export const guestMenuItems: Array<NavItemGuest> = [
  {
    label: 'Kelembagaan Penyuluhan',
    children: [
      {
        icon: Signal,
        label: 'Rekap Kelembagaan Penyuluhan',
        description: 'Gambaran Umum Data',
        href: '/guest/recap-extensions-institutions'
      },
      {
        icon: FileText,
        label: 'Rekap Klasifikasi BPP',
        description:
          'Rekapitulasi klasifikasi Balai Penyuluhan Pertanian (BPP)',
        href: '/guest/recap-classifications-bpp'
      },
      {
        icon: Files,
        label: 'Daftar Kelembagaan Penyuluhan',
        description: 'Daftar lengkap Kelembagaan penyuluhan',
        href: '/guest/extensions-institutions'
      }
    ]
  },
  {
    label: 'Ketenagaan Penyuluhan',
    children: [
      {
        icon: Signal,
        label: 'Rekap Ketenagaan Penyuluhan',
        description: 'Gambaran Umum Data',
        href: '/guest/recap-extentions-worker'
      },
      {
        icon: FileText,
        label: 'Daftar Ketenagaan Penyuluhan',
        description: 'Data Ketenagaan Penyuluh yang terdaftar',
        href: '/guest/ktg-worker-list'
      }
    ]
  },
  {
    label: 'Kelembagaan Pelaku Utama',
    children: [
      {
        icon: Signal,
        label: 'Rekap Kelembagaan Petani',
        description: 'Rekapitulasi data kelembagaan petani',
        href: '/guest/recap-farmer-institutions'
      },
      {
        icon: Users,
        label: 'Kelompok Tani',
        description: 'Data dan rekapitulasi Poktan',
        children: [
          {
            icon: FileText,
            label: 'Daftar Poktan',
            description: 'Daftar lengkap kelompok tani',
            href: '/guest/list-poktan'
          },
          {
            icon: Signal,
            label: 'Rekap Jenis Poktan',
            description: 'Rekap berdasarkan jenis kelompok tani',
            href: '/guest/recap-poktan'
          },
          {
            icon: Signal,
            label: 'Rekap Kelas Poktan',
            description: 'Rekap berdasarkan kelas kelompok tani',
            href: '/guest/recap-class-poktan'
          },
          {
            icon: FileText,
            label: 'Daftar Anggota Poktan',
            description: 'Daftar lengkap anggota kelompok tani',
            href: '/guest/list-poktan-member'
          }
        ]
      },
      {
        icon: Layers,
        label: 'Gabungan Kelompok Tani',
        description: 'Data rekapitulasi Gapoktan',
        children: [
          {
            icon: FileText,
            label: 'Daftar Gapoktan',
            description: 'Data Gabungan Kelompok Petani yang terdaftar',
            href: '/guest/list-gapoktan'
          }
        ]
      },
      {
        icon: Landmark,
        label: 'Kelembagaan Ekonomi Petani',
        description: 'Data dan rekapitulasi KEP',
        children: [
          {
            icon: FileText,
            label: 'Daftar KEP',
            description: 'Daftar kelembagaan ekonomi petani (KEP)',
            href: '/guest/list-kep'
          },
          {
            icon: Signal,
            label: 'Rekap Bentuk KEP',
            description:
              'Rekap berdasarkan bentuk Kelembagaan Ekonomi Petani (KEP)',
            href: '/guest/recap-shape-kep'
          }
        ]
      }
    ]
  },
  {
    label: 'Cari Data',
    children: [
      {
        icon: FileText,
        label: 'Ketenagaan Penyuluh',
        description: 'Cari data terkait ketenagaan penyuluh',
        href: '/guest/ktg-worker-list?tab=district'
      },
      {
        icon: FileText,
        label: 'Kelembagaan Petani',
        description: 'Cari data kelembagaan petani',
        children: [
          {
            icon: FileText,
            label: 'Poktan',
            description: 'Daftar kelompok tani',
            href: '/guest/list-poktan'
          },
          {
            icon: FileText,
            label: 'Gapoktan',
            description: 'Daftar gabungan kelompok tani',
            href: '/guest/list-gapoktan'
          },
          {
            icon: FileText,
            label: 'KEP',
            description: 'Daftar kelembagaan ekonomi petani',
            href: '/guest/list-kep'
          }
        ]
      },
      {
        icon: FileText,
        label: 'Petani Anggota Poktan',
        description: 'Cari data petani anggota kelompok tani',
        href: '/guest/list-poktan-member'
      }
    ]
  }
]

export const chartColors = [
  '#02b875', // Green
  '#f0ad4e', // Orange
  '#7cb5ec', // Light Blue
  '#434348', // Dark Gray
  '#90ed7d', // Light Green
  '#f7a35c', // Light Orange
  '#8085e9', // Light Purple
  '#f15c80', // Light Pink
  '#e4d354', // Light Yellow
  '#2b908f', // Teal
  '#f45b5b', // Red
  '#91e8e1', // Light Teal
  '#e4d354' // Light Yellow
]

export const bidangUsahaOptions = [
  { label: 'Alsintan', value: 'Alsintan' },
  { label: 'Obat-obatan/Pestisida', value: 'Obat-obatan/Pestisida' },
  { label: 'Benih/Bibit', value: 'Benih/Bibit' },
  { label: 'Pupuk', value: 'Pupuk' },
  { label: 'Pakan Ternak', value: 'Pakan Ternak' },
  { label: 'Keuangan/Permodalan', value: 'Keuangan/Permodalan' }
]

export const bidangPendidikanOptions = [
  { label: 'Pertanian', value: 'PERTANIAN' },
  { label: 'Non Pertanian', value: 'NON_PERTANIAN' }
]

export const kondisiBangunanOptions = [
  { label: 'Rusak', value: 'RUSAK' },
  { label: 'Baik', value: 'BAIK' }
]

export const statusBangunanOptions = [
  { label: 'Milik Sendiri', value: 'MILIK_SENDIRI' },
  { label: 'Sewa/Pinjam', value: 'SEWA_PINJAM' }
]

export const jenisAnggaranOptions = [
  { label: 'Fisik', value: 'FISIK' },
  { label: 'Non Fisik', value: 'NON_FISIK' }
]

export const penggunaanAnggaranOptions = [
  { label: 'Pembangunan', value: 'PEMBANGUNAN' },
  { label: 'Renovasi', value: 'RENOVASI' },
  { label: 'Sarana Prasarana', value: 'SARANA_PRASARANA' }
]

export const jenisKelembagaanProvinsiOptions = [
  { label: 'BADAN', value: 'BADAN' },
  { label: 'DINAS', value: 'DINAS' }
]

export const jenisKelembagaanPusatOptions = [
  { label: 'BPPSDMP', value: 'BPPSDMP' },
  { label: 'BBPPMP', value: 'BBRMP' },
  { label: 'BRMP', value: 'BRMP' }
]

export const roleNames = {
  superAdmin: 'super_admin',
  adminPusat: 'admin_pusat',
  adminProvinsi: 'admin_provinsi',
  adminKota: 'admin_kota',
  adminKecamatan: 'admin_kecamatan',
  adminBpp: 'admin_bpp',
  penyuluh: 'penyuluh'
} as const

export const PATTERN = {
  DATE: 'YYYY-MM-DD',
  FILENAME_REGEX: /filename[^;=\n]*=((['"]).*?\2|[^;\n]*)/
}
